<template>
  <div>
    <Spinner :is-loading="isDocumentsLoading" />
    <div v-if="!isDocumentsLoading" :id="`${type}-documents`">
      <p>Seleccione los documentos que comprueben la <span class="is-lowercase">{{ label }}</span>:</p>
      <div v-if="uploadedDocuments.length > 0">
        <div
          v-for="(report, index) in uploadedDocuments"
          :key="index"
          data-cy="uploaded-documents"
          class="separator">
          {{ report.pdfFileName }}
        </div>
      </div>
      <b-button
        class="add"
        size="is-small"
        icon="plus"
        type="mr-4 mb-1 mt-4"
        icon-left="plus"
        rounded
        @click="selectDocument">
        Subir nuevo documento
      </b-button>
      <input
        ref="fileInput"
        type="file"
        accept="application/pdf"
        hidden
        @change="handleFileUpload">
      <p
        v-if="validateDocuments && uploadedDocuments.length === 0"
        class="help is-danger"
        data-cy="error-message">
        Se requiere subir al menos un archivo para comprobar la información registrada.
      </p>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { BffEvaluationsClient } from '@/application/services/evaluations/apis/bff-evaluations-client';
import { EvaluationsClient } from '@/application/services/evaluations/apis/evaluations-client';
import { evaluationsBackend } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';
import Spinner from '@/ui/components/Spinner.vue';

export default {
  name: 'DocumentsVerification',
  components: { Spinner },
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    evaluationId: {
      type: String,
      required: true
    },
    oneClientId: {
      type: Number,
      required: true
    },
    validateDocuments: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isDocumentsLoading: false,
      uploadedDocuments: [],
      bffEvaluationsClient: new BffEvaluationsClient(evaluationsBackend, authenticationService),
      evaluationClient: new EvaluationsClient(evaluationsBackend, authenticationService)
    };
  },
  computed: {
    ...mapState('evaluation', ['idNumber'])
  },
  methods: {
    selectDocument() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const [file] = event.target.files;
      if (file) {
        this.uploadedDocuments.push({
          pdfFileName: file.name
        });
        this.addFileToEvaluations(file);
        this.$refs.fileInput.value = '';
      }
    },
    async addFileToEvaluations(file) {
      if (!this.oneClientId) {
        throw new Error(`No se pudo subir los documentos clientId: ${this.oneClientId}`);
      }
      this.isDocumentsLoading = true;
      try {
        const files = new FormData();
        files.append(this.type, file);
        const response = await this.bffEvaluationsClient.addFileToEvaluations(this.oneClientId, this.idNumber, this.evaluationId, files);
        this.$emit('documents-uploaded', this.uploadedDocuments.length);
        return response.data;
      } catch (error) {
        this.$log.error(`No se pudo subir los documentos. Cause: ${error.message}`);
      } finally {
        this.isDocumentsLoading = false;
      }
      return [];
    }
  }
};
</script>

<style scoped>

</style>
